
export const LanguageNames: Record<string, string> = {
  EN: 'English',
  ZH: 'Chinese',
}

/**
 * Get the name of a language from its code
 * @param code - The code of the language
 * @returns The name of the language
 */
export const getLanguageName = (code: string) => {
  return LanguageNames[code] || code
}
